import '@fontsource-variable/inter/index.css';
import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import './theme/tokens.css';
import './theme/components.css';
import './theme/livekit.css';
import './app/global.css';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

import './i18n';
import { App } from './app/app';
import { SignInPage } from './pages/sign-in/sign-in-page';
import { cssVariablesResolver, theme } from './theme/theme';

const { SENTRY_DSN, SENTRY_ENVIRONMENT, APP_VERSION, DEV } = import.meta.env;

Sentry.init({
    dsn: SENTRY_DSN,
    enabled: Boolean(SENTRY_DSN),
    environment: SENTRY_ENVIRONMENT || (DEV ? 'development' : 'production'),
    release: APP_VERSION ? `meet@${APP_VERSION}` : undefined,
    integrations: [
        Sentry.reactRouterBrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: DEV ? 1 : 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
});

const PATHS_WITHOUT_LOGIN = ['/egress-template', '/recordings/s/'];

const sessionResponse = PATHS_WITHOUT_LOGIN.some((path) => location.pathname.startsWith(path))
    ? undefined
    : await fetch('/api/me').catch(() => undefined);

const root = document.querySelector('#root');
if (!root) throw new Error('#root не найден в index.html');

createRoot(root, {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
}).render(
    <MantineProvider cssVariablesResolver={cssVariablesResolver} forceColorScheme="dark" theme={theme}>
        <Notifications layout="stacked" position="top-center" />
        {sessionResponse?.status === 401 ? <SignInPage /> : <App />}
    </MantineProvider>
);
